@import "../../globalStyles/commons";

$tag-background-color: var(--tag-background-color, var(--tag-background-gray));
$tag-color: var(--tag-color, var(--tag-color-gray));
$tag-hover-color: var(--tag-hover-color, var(--tag-hover-gray));

:host {
  display: inline-block;
}

.tag {
  @include font-style(label-01);
  background: $tag-background-color;
  color: $tag-color;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .tag-image {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 100%;
    background: $tag-hover-color;
  }

  .tag-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    padding: 0 .5rem;
    display: flex;
    align-items: center;
  }

  &.dismissible .tag-content {
    padding-inline-end: .25rem;
  }

  &.selected {
    color: var(--background);
    background: $tag-hover-color;

    .close-btn-icon {
      color: var(--background);
    }
  }
}


.close-btn {
  border-radius: 12px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  line-height: 0;
  cursor: pointer;
  margin-inline-end: var(--spacing-01);

  &:hover {
    background: $tag-hover-color;

    .close-btn-icon {
      color: var(--background);
    }
  }
}

/**
 * Sizes
 */
.tag.size-md {
  height: 1.5rem;
  border-radius: 12px;
}


.tag.size-sm {
  height: 1.125rem;
  border-radius: 9px;
}

@each $color in ['gray', 'blue', 'green', 'red', 'yellow', 'primary', 'success', 'info', 'warning', 'error'] {
  .tag#{'.color-' + $color} {
    --tag-background-color: var(--tag-background-#{$color});
    --tag-color: var(--tag-color-#{$color});
    --tag-hover-color: var(--tag-hover-#{$color});
  }
}
